<template>
    <div class="content ht-100v pd-0">
      <main-header txt="Зорчилт & торгууль">
        <!-- <div></div>sdf -->
      </main-header>
      <div class="content-body pd-0-f" >
        <div class="container pd-0-f">
          <div class="card bd-0 bd-none" >
              
              <div class="card-body pd-0">
                <iframe src="https://zhut-dash-report.gosmart.mn/home/reports?r=static02" border="0" width="100%" style="border:none; height: calc(100vh - 60px);"></iframe>
              </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import AsyncLoadError from "@/components/base/asyncLoadingError";
  import AsyncLoading from "@/components/base/asyncLoading";
  
  export default {
    components:{
      mainHeader: () => ({
        component: import("@/views/apps/penalty/components/header.vue"),
        loading: AsyncLoading,
        error: AsyncLoadError,
        delay: 100,
        timeout: 5000,
      }),
    },
  }
  </script>
  
  